import { createSelector } from 'reselect';
import IpcEquipmentPoolsPredesResdesAnalysisIpcTrayIlColumns
  from '../../containers/IpcEquipmentPoolsPredesResdesAnalysisIpcTrayIlColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.IPC_TRAY_IL_PREDES_RESDES_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.IPC_TRAY_IL_PREDES_RESDES_ANALYSIS.isLoading;

export const getData =
  ReportDefinitions.IPC_TRAY_IL_PREDES_RESDES_ANALYSIS.getDataFunction();

export const getColumns =
  createSelector(getData, IpcEquipmentPoolsPredesResdesAnalysisIpcTrayIlColumns);
